<template>
  <div class="row">
    <div class="col" v-if="docType !== 'ORIPOX'">
      <div class="row">
        <div v-if="showSiteFilter" class="col filter_separator">
          <h6 class="heading-small text-muted">Company</h6>
          <base-input>
            <a-select showSearch v-model="filterText.filterCompany" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="Select a Company" allowClear @dropdownVisibleChange="openCompanyOptions">
              <a-select-option v-for="option in filterCompanyOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
            </a-select>
          </base-input>
        </div>
        <div v-if="showSiteFilter && isHo == 'ho'" class="col filter_separator">
          <h6 class="heading-small text-muted">Site</h6>
          <div class="input-group mb-3">
            <a-select
              labelInValue
              showSearch
              :value="filterSite"
              placeholder="Select a site"
              style="width: 100%"
              :filterOption="filterOption"
              @dropdownVisibleChange="fetchSites"
              @change="selectSite"
              :notFoundContent="fetching ? undefined : null"
              >
              <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
              <a-select-option v-for="s in sites" :key="s.id.toString()">{{s.name}}</a-select-option>
            </a-select>
          </div>
        </div>

        <div class="col filter_separator">
          <h6 class="heading-small text-muted">Document Date</h6>
            <div style="margin-bottom:0;">
              <a-range-picker suffixIcon=' ' @change="onDateFilter" v-model="filterText.defaultFilterDateValue" :placeholder="datePickerPlaceholder" />
            </div>
        </div>

        <div class="col filter_separator">
          <h6 class="heading-small text-muted">Filter Date By</h6>
            <div style="margin-bottom:0;">
                  <a-select v-model="filterText.filterDateBy" style="width: 100%">
                    <a-select-option value="document_date">
                      Document Date
                    </a-select-option>
                    <a-select-option value="posted_at">
                      Post Date
                    </a-select-option>
                  </a-select>
            </div>
        </div>

        <div class="col filter_separator">
          <h6 class="heading-small text-muted">Status</h6>
            <a-select placeholder="Status" style="width: 100%" v-model="filterText.filterStatus">
              <a-select-option v-for="option in filterStatusOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
            </a-select>
        </div>

        <div v-if="showWmsStatus" class="col filter_separator">
          <h6 class="heading-small text-muted">WMS status</h6>
          <a-select placeholder="WMS status" style="width: 100%" v-model="filterText.filterWmsStatus">
            <a-select-option v-for="option in filterWmsStatusOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
          </a-select>
        </div>

        <div v-if="('showOrderStatus' && docType == 'RELDDE' || docType == 'ORISOX' || docType == 'ORIOSO' || docType == 'ORIASN' || docType == 'ORIPOX')" class="col filter_separator">
          <h6 class="heading-small text-muted">Order status</h6>
          <a-select v-if="docType == 'RELDDE'" placeholder="Order Status" style="width: 100%" v-model="filterText.filterOrderStatus">
            <a-select-option v-for="option in filterDeliveryOrderStatusOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
          </a-select>
          <a-select v-else placeholder="Order Status" style="width: 100%" v-model="filterText.filterOrderStatus">
            <a-select-option v-for="option in filterOrderStatusOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
          </a-select>
        </div>

        <div v-if="showOmsStatus" class="col filter_separator">
          <h6 class="heading-small text-muted">OMS status</h6>
          <a-select placeholder="" style="width: 100%" v-model="filterText.filterOmsStatus">
            <a-select-option v-for="option in filterOmsStatusOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
          </a-select>
        </div>

        <div v-if="showOriginDocumentFilter" class="col filter_separator">
          <h6 class="heading-small text-muted">Origin Document #</h6>
          <div class="input-group mb-3">
              <a-input style="width: 100%" placeholder="Origin Document #"  v-model="filterText.filterDocumentCode"/>
          </div>
        </div>

        <div v-if="showDocumentNoFilter" class="col filter_separator">
          <h6 class="heading-small text-muted">Document #</h6>
          <div class="input-group mb-3">
              <a-input style="width: 100%" placeholder="Document #"  v-model="filterText.filterDocumentNo"/>
          </div>
        </div>

        <div class="col d-flex align-items-center filter_separator">
          <button type="button" class="btn btn-info btn-sm btn-block mt-3 mr-2" @click='applyFilter'>Apply Filter</button>
          <button type="button" class="btn btn-outline-primary btn-sm btn-block mt-3" @click='clearFilters'>Reset Filter</button>
        </div>

      </div>

      <!-- Additional filter fields -->
      <div class="row mb-3">
        <div v-if="showBrandFilter" class="col filter_separator">
          <h6 class="heading-small text-muted">Brand</h6>
          <base-input>
            <a-select showSearch v-model="filterText.filterBrands" mode="multiple" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="All Brands" allowClear @dropdownVisibleChange="openBrandOptions">
              <a-select-option v-for="brandOption in filterBrandOptions" :key="brandOption.id" :value="brandOption.id">{{brandOption.name}}</a-select-option>
            </a-select>
          </base-input>
        </div>

        <div v-if="showBarcodeFilter" class="col filter_separator">
          <h6 class="heading-small text-muted">Barcode</h6>
          <div class="input-group mb-3">
              <a-input style="width: 100%" placeholder="Barcode"  v-model="filterText.filterBarcode"/>
          </div>
        </div>

        <div v-if="showOrderTypeFilter" class="col filter_separator">
          <h6 class="heading-small text-muted">Order Type</h6>
          <a-select showSearch placeholder="Select Order Type" style="width: 100%" v-model="filterText.filterOrderType" allowClear>
            <a-select-option v-for="option in filterOrderTypeOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
          </a-select>
        </div>

        <div v-if="showCountryOfOriginFilter" class="col filter_separator">
          <h6 class="heading-small text-muted">Country Of Origin</h6>
          <base-input>
            <a-select showSearch placeholder="Select Country" v-model="filterText.filterCountryOfOrigin" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" allowClear @dropdownVisibleChange="openCountryOptions">
              <a-select-option v-for="countryOption in filterCountryOfOriginOptions" :key="countryOption.id" :value="countryOption.id">{{countryOption.name}}</a-select-option>
            </a-select>
          </base-input>
        </div>

        <div v-if="showFiscalYearFilter" class="col filter_separator">
          <h6 class="heading-small text-muted">Fiscal Year</h6>
          <a-select showSearch placeholder="Select Fiscal Year" style="width: 100%" v-model="filterText.filterFiscalYear" allowClear>
            <a-select-option v-for="option in filterFiscalYearOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
          </a-select>
        </div>

        <div v-if="showPartyNameFilter" class="col filter_separator">
          <h6 class="heading-small text-muted">Party Name</h6>
          <div class="input-group mb-3">
              <a-input style="width: 100%" placeholder="Party Name" v-model="filterText.filterPartyName"/>
          </div>
        </div>

        <div v-if="showB2bCustomerFilter" class="col filter_separator">
          <h6 class="heading-small text-muted">Customer</h6>
          <base-input>
              <a-auto-complete
                  style="width: 100%"
                  placeholder="Select a Customer"
                  :filter-option="filterOption"
                  @select="selectB2bCustomer"
                  :value="b2b.label"
                  @search="fetchB2bCustomers"
                  @focus="fetchB2bCustomers"
                  optionFilterProp="children"
                  @change="handleAutoCompleteChange"
                  allowClear>
                  <template slot="dataSource">
                      <a-select-option v-for="b in b2bs" :key="'b2b'+b.id.toString()" :text="b.name">{{b.name}}</a-select-option>
                  </template>
              </a-auto-complete>
            </base-input>
        </div>

        <div v-if="showCustomerFilter" class="col filter_separator">
          <h6 class="heading-small text-muted">Customer</h6>
          <base-input label="Customer">
              <a-auto-complete
                  style="width: 100%"
                  placeholder="Select a Customer"
                  :filter-option="filterOption"
                  @select="selectCustomer"
                  :value="customer.label"
                  @search="fetchCustomers"
                  @focus="fetchCustomers"
                  :allowClear='true'>
                  <template slot="dataSource">
                      <a-select-option v-for="c in customers" :key="'customer'+c.id.toString()" :text="c.name">{{c.name}}</a-select-option>
                  </template>
              </a-auto-complete>
          </base-input>
        </div>

        <div v-if="showSiteConceptFilter" class="col filter_separator">
          <h6 class="heading-small text-muted">Site Concept</h6>
          <base-input>
            <a-select showSearch v-model="filterText.filterSiteConcept" mode="multiple" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="Select Site Concepts" allowClear @dropdownVisibleChange="openSiteConceptOptions">
              <a-select-option v-for="siteConceptOption in filterSiteConceptOptions" :key="siteConceptOption.id" :value="siteConceptOption.id">{{ siteConceptOption.name }}</a-select-option>
            </a-select>
          </base-input>
        </div>

        <div v-if="showProdStockNoFilter" class="col filter_separator">
          <h6 class="heading-small text-muted">Stock No.</h6>
          <base-input>
            <a-select
              showSearch
              v-model="filterText.filterProdStockNo"
              mode="multiple"
              optionFilterProp="children"
              style="width: 100%"
              placeholder="Search Stock No."
              allowClear
              @search="handleDropdownSearchData"
            >
              <a-select-option v-for="prodStockNoOption in filterProdStockNoOptions" :key="prodStockNoOption.id" :value="prodStockNoOption.id">
                {{ prodStockNoOption.stock_no }}
              </a-select-option>
            </a-select>
          </base-input>
        </div>
        <div v-if="showCasNo" class="col filter_separator">
          <h6 class="heading-small text-muted">Cas No.</h6>
          <div class="input-group mb-3">
           <a-input v-model="filterText.filterCasNo" placeholder="Cas No." style="width: 100%"/>
          </div>
        </div>

        <div v-if="showYearSeasonFilter" class="col filter_separator">
          <h6 class="heading-small text-muted">Year Season</h6>
          <div class="input-group mb-3">
              <a-input style="width: 100%" placeholder="Year Season" v-model="filterText.filterYearSeason"/>
          </div>
        </div>
      </div>
      <div class="row mx-1" v-if="currentProfile !== 'product_price_worksheets'" >
        <a-collapse style="width: 100%; background: #FFFFFF;" @change="openDrawer">
            <a-collapse-panel header="Advanced Filter" >
              <div class="col">
                <!-- {{documentReference}} -->
                <!-- {{referenceFilters}} -->
                <h6 class="heading-small text-muted">Reference Filter</h6>

                <a-input-group compact>
                  <a-select style="width: 20%" v-model="selectedRefFilter">
                    <a-select-option v-for="option in documentReference" :key="option.name">{{option.name}}</a-select-option>
                  </a-select>
                  <a-input style="width: 80%" @keypress.enter="addReferenceFilter" v-model="searchText"/>
                  <!-- <a-button slot="addonAfter">+</a-button> -->
                </a-input-group>
                <small class="text-muted">Matches exactly. Add % for a partial match (e.g. ABC% or %ABC%).</small>

                <div id="filterDiv">
                  <small>Reference Filters:</small>  &nbsp;
                  <div v-if="tags.length > 0">
                    <template v-for="tag in tags">
                      <a-tag :key="tag" :afterClose="() => handleClose(tag)" color="blue" closable>
                        {{tag}}
                      </a-tag>
                    </template>
                  </div>
                  <div v-else>
                    <a-tag> No reference filters applied</a-tag>
                  </div>
                  <br/>
                </div>
                <a-spin :spinning="loadUserInfos">
                <div class="row">
                  <div class="col">
                    <h6 class="heading-small text-muted">Supplier</h6>
                    <base-input>
                      <a-select showSearch v-model="filterText.filterSupplier" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="Select a Supplier" allowClear @dropdownVisibleChange="openSupplier">
                        <a-select-option v-for="option in filterSupplierOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                      </a-select>
                    </base-input>
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Created By</h6>
                    <base-input>
                      <a-select showSearch v-model="filterText.filterCreatedBy" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="Select a User" allowClear @dropdownVisibleChange="openUserList">
                        <a-select-option v-for="option in filterCreatedByOptions" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                      </a-select>
                    </base-input>
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Posted By</h6>
                    <base-input>
                      <a-select showSearch v-model="filterText.filterPostedBy" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="Select a User" allowClear @dropdownVisibleChange="openUserList">
                        <a-select-option v-for="option in filterPostedByOptions" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                      </a-select>
                    </base-input>
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Deliver To</h6>
                    <a-select style="width: 100%" v-model="filterText.filterDeliveryTo" @dropdownVisibleChange="openDeliveryToOptions" showSearch :filterOption="filterOption">
                      <a-select-option v-for="option in filterDeliveryToOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
                    </a-select>
                  </div>
                </div>
                 <div class="row mt-3">
                  <div class="col-3" v-if="showTerminalFilter">
                      <h6 class="heading-small text-muted">Select Terminal</h6>
                      <a-select style="width: 100%" v-model="filterText.selectedTerminalName" @dropdownVisibleChange="openTerminalOptions">
                        <a-select-option v-for="option in terminalNames" v-bind:key="option.key">{{ option.value }}
                        </a-select-option>
                      </a-select>
                    </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Select Order</h6>
                    <a-select style="width: 100%" v-model="filterText.selectedOrder">
                      <a-select-option v-for="option in selectOrder" v-bind:key="option.key">{{option.value}}</a-select-option>
                    </a-select>
                  </div>
                  <div v-if='filterText.selectedOrder == 0'  class="col">
                    <h6 class="heading-small text-muted">Order #</h6>
                      <a-select placeholder="Status" style="width: 100%" v-model="filterText.filterOrderNo">
                      <a-select-option v-for="option in filterOrderNoOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
                    </a-select>
                  </div>
                  <div v-if='filterText.selectedOrder == 1'  class="col">
                    <h6 class="heading-small text-muted">Origin #</h6>
                      <a-select placeholder="Status" style="width: 100%" v-model="filterText.filterOriginNo">
                      <a-select-option v-for="option in filterOriginNoOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
                    </a-select>
                  </div>
                  <div v-if='filterText.selectedOrder == 2'  class="col">
                    <h6 class="heading-small text-muted">Quantity</h6>
                      <a-select placeholder="Status" style="width: 100%" v-model="filterText.filterQuantity">
                      <a-select-option v-for="option in filterQunatityOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
                    </a-select>
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Purpose</h6>
                    <a-select  style="width: 100%" v-model="filterText.filterPurpose" @dropdownVisibleChange="openPurpose">
                        <a-select-option v-for="option in filterPurposeOptions" v-bind:key="option.id">
                          {{option.name}}
                        </a-select-option>
                    </a-select>
                  </div>
                  <div v-if="showOrderSource" class="col">
                    <h6 class="heading-small text-muted">Source</h6>
                    <a-select showSearch placeholder="Select Order Source" style="width: 100%" v-model="filterText.filterOrderSource" allowClear>
                      <a-select-option v-for="option in filterOrderSourceOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
                    </a-select>
                  </div>
                </div>
                </a-spin>
              </div>
            </a-collapse-panel>
        </a-collapse>
      </div>
    </div>

       <!-- /barter-11/bxi-backend/-/issues/2252 -->
      <!-- TESTING LAYOUT FOR ORIPOX FILTER -->
      <div class="col" v-else>
        <div class="row">
          <div v-if="showSiteFilter" class="col">
            <h6 class="heading-small text-muted">Company</h6>
            <base-input>
              <a-select showSearch v-model="filterText.filterCompany" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="Select a Company" allowClear @dropdownVisibleChange="openCompanyOptions">
                <a-select-option v-for="option in filterCompanyOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
              </a-select>
            </base-input>
          </div>
        </div>
        <div class="row">
          <div v-if='showSiteFilter' class="col">
            <h6 class="heading-small text-muted">Site</h6>
            <div class="input-group mb-3">
              <a-select labelInValue showSearch :value="filterSite" placeholder="Select a site" style="width: 100%"
                :filterOption="filterOption" @dropdownVisibleChange="fetchSites" @change="selectSite"
                :notFoundContent="fetching ? undefined : null">
                <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="s in sites" :key="s.id.toString()">{{ s.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- /barter-11/bxi-backend/-/issues/2252 -->
          <!-- 1A make document date view wider -->
          <div class="col-3">
            <h6 class="heading-small text-muted">Document Date</h6>
            <div style="margin-bottom:0;">
              <a-range-picker suffixIcon=' ' @change="onDateFilter" v-model="filterText.defaultFilterDateValue"
                :placeholder="datePickerPlaceholder" />
            </div>
          </div>

          <div class="col">
            <h6 class="heading-small text-muted">Filter Date By</h6>
            <div style="margin-bottom:0;">
              <a-select v-model="filterText.filterDateBy" style="width: 100%">
                <a-select-option value="document_date">
                  Document Date
                </a-select-option>
                <a-select-option value="posted_at">
                  Post Date
                </a-select-option>
              </a-select>
            </div>
          </div>

          <div class="col">
            <h6 class="heading-small text-muted">Status</h6>
            <a-select placeholder="Status" style="width: 100%" v-model="filterText.filterStatus">
              <a-select-option v-for="option in filterStatusOptions" v-bind:key="option.key">{{ option.value }}
              </a-select-option>
            </a-select>
          </div>

          <div v-if='showWmsStatus' class="col">
            <h6 class="heading-small text-muted">WMS status</h6>
            <a-select placeholder="WMS Status" style="width: 100%" v-model="filterText.filterWmsStatus">
              <a-select-option v-for="option in filterWmsStatusOptions" v-bind:key="option.key">{{ option.value }}</a-select-option>
            </a-select>
          </div>

          <div v-if="('showOrderStatus' && docType == 'RELDDE' || docType == 'ORISOX'|| docType == 'ORIOSO' || docType == 'ORIASN' || docType == 'ORIPOX')" class="col">
            <h6 class="heading-small text-muted" >Order status</h6>
            <a-select v-if="docType == 'RELDDE'" placeholder="Order Status" style="width: 100%"
              v-model="filterText.filterOrderStatus">
              <a-select-option v-for="option in filterDeliveryOrderStatusOptions" v-bind:key="option.key">{{ option.value
              }}
              </a-select-option>
            </a-select>
            <a-select v-else placeholder="Order Status" style="width: 100%" v-model="filterText.filterOrderStatus">
              <a-select-option v-for="option in filterOrderStatusOptions" v-bind:key="option.key">{{ option.value }}
              </a-select-option>
            </a-select>
          </div>

          <div v-if='showOmsStatus' class="col">
            <h6 class="heading-small text-muted">OMS status</h6>
            <a-select placeholder="OMS Status" style="width: 100%" v-model="filterText.filterOmsStatus">
              <a-select-option v-for="option in filterOmsStatusOptions" v-bind:key="option.key">{{ option.value }}
              </a-select-option>
            </a-select>
          </div>

          <div v-if='showOriginDocumentFilter' class="col">
            <h6 class="heading-small text-muted">Origin Document #</h6>
            <div class="input-group mb-3">
              <a-input style="width: 100%" placeholder="Origin Document #" v-model="filterText.filterDocumentCode" />
            </div>
          </div>

          <div v-if='showDocumentNoFilter' class="col">
            <h6 class="heading-small text-muted">Document #</h6>
            <div class="input-group mb-3">
              <a-input style="width: 100%" placeholder="Document #" v-model="filterText.filterDocumentNo" />
            </div>
          </div>

          <div class="col d-flex align-items-center">
            <button type="button" class="btn btn-info btn-sm btn-block mt-3 mr-2" @click='applyFilter'>Apply Filter</button>
            <button type="button" class="btn btn-outline-primary btn-sm btn-block mt-3" @click='clearFilters'>Reset Filter</button>
          </div>

        </div>
        <!-- Additional filter fields -->
        <div class="row mb-3">
          <div v-if='showBrandFilter' class="col">
            <h6 class="heading-small text-muted">Brand</h6>
              <base-input>
                <a-select showSearch v-model="filterText.filterBrands" mode="multiple" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="All Brands" allowClear @dropdownVisibleChange="openBrandOptions">
                  <a-select-option v-for="brandOption in filterBrandOptions" :key="brandOption.id" :value="brandOption.id">{{brandOption.name}}</a-select-option>
                </a-select>
              </base-input>
          </div>

          <div v-if="showBarcodeFilter" class="col">
            <h6 class="heading-small text-muted">Barcode</h6>
            <div class="input-group mb-3">
                <a-input style="width: 100%" placeholder="Barcode"  v-model="filterText.filterBarcode"/>
            </div>
          </div>

          <div v-if='showOrderTypeFilter' class="col">
            <h6 class="heading-small text-muted">Order Type</h6>
            <a-select showSearch placeholder="Select Order Type" style="width: 100%" v-model="filterText.filterOrderType" allowClear>
              <a-select-option v-for="option in filterOrderTypeOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
            </a-select>
          </div>

          <div v-if="showCountryOfOriginFilter" class="col">
            <h6 class="heading-small text-muted">Country Of Origin</h6>
            <base-input>
              <a-select showSearch v-model="filterText.filterCountryOfOrigin" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="Select Country" allowClear @dropdownVisibleChange="openCountryOptions">
                <a-select-option v-for="countryOption in filterCountryOfOriginOptions" :key="countryOption.id" :value="countryOption.id">{{countryOption.name}}</a-select-option>
              </a-select>
            </base-input>
          </div>

          <div v-if='showFiscalYearFilter' class="col">
            <h6 class="heading-small text-muted">Fiscal Year</h6>
            <a-select showSearch placeholder="Fiscal Year" style="width: 100%" v-model="filterText.filterFiscalYear" allowClear>
              <a-select-option v-for="option in filterFiscalYearOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
            </a-select>
          </div>

          <div v-if="showCustomerFilter" class="col">
            <base-input label="Customer">
              <a-auto-complete
                  style="width: 100%"
                  placeholder="Select a Customer"
                  :filter-option="filterOption"
                  @select="selectCustomer"
                  :value="customer.label"
                  @search="fetchCustomers"
                  @focus="fetchCustomers"
                  :allowClear='true'>
                  <template slot="dataSource">
                      <a-select-option v-for="c in customers" :key="'customer'+c.id.toString()" :text="c.name">{{c.name}}</a-select-option>
                  </template>
              </a-auto-complete>
          </base-input>
          </div>

          <div v-if='showYearSeasonFilter' class="col">
            <h6 class="heading-small text-muted">Year Season</h6>
            <div class="input-group mb-3">
              <a-input style="width: 100%" placeholder="Year Season" v-model="filterText.filterYearSeason" />
            </div>
          </div>
        </div>

        <div class="row mx-1">
          <a-collapse style="width: 100%; background: #FFFFFF;" @change="openDrawer">
            <a-collapse-panel header="Advanced Filter">
              <div class="col">
                <!-- {{documentReference}} -->
                <!-- {{referenceFilters}} -->
                <h6 class="heading-small text-muted">Reference Filter</h6>

                <a-input-group compact>
                  <a-select style="width: 20%" v-model="selectedRefFilter">
                    <a-select-option v-for="option in documentReference" :key="option.name">{{ option.name }}
                    </a-select-option>
                  </a-select>
                  <a-input style="width: 80%" @keypress.enter="addReferenceFilter" v-model="searchText" />
                  <!-- <a-button slot="addonAfter">+</a-button> -->
                </a-input-group>
                <small class="text-muted">Matches exactly. Add % for a partial match (e.g. ABC% or %ABC%).</small>

                <div id="filterDiv">
                  <small>Reference Filters:</small> &nbsp;
                  <div v-if="tags.length > 0">
                    <template>
                      <a-tag v-for="tag in tags" :key="tag" :afterClose="() => handleClose(tag)" color="blue" closable>
                        {{ tag }}
                      </a-tag>
                    </template>
                  </div>
                  <div v-else>
                    <a-tag> No reference filters applied</a-tag>
                  </div>
                  <br />
                </div>
                <a-spin :spinning="loadUserInfos">

                  <div class="row">
                    <!-- /barter-11/bxi-backend/-/issues/2252 -->
                    <!-- 1B Change Advance Filter UI arrangement -->
                    <div class="col-6">
                      <h6 class="heading-small text-muted">Supplier</h6>
                      <base-input>
                        <a-select showSearch v-model="filterText.filterSupplier" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="Select a Supplier" allowClear @dropdownVisibleChange="openSupplier">
                          <a-select-option v-for="option in filterSupplierOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                        </a-select>
                      </base-input>
                    </div>

                    <div class="col-3">
                      <h6 class="heading-small text-muted">Created By</h6>
                      <base-input>
                        <a-select showSearch v-model="filterText.filterCreatedBy" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="Select a User" allowClear @dropdownVisibleChange="openUserList">
                          <a-select-option v-for="option in filterCreatedByOptions" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                        </a-select>
                      </base-input>
                    </div>

                    <div class="col-3">
                      <h6 class="heading-small text-muted">Posted By</h6>
                      <base-input>
                        <a-select showSearch v-model="filterText.filterPostedBy" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="Select a User" allowClear @dropdownVisibleChange="openUserList">
                          <a-select-option v-for="option in filterPostedByOptions" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                        </a-select>
                      </base-input>
                    </div>

                  </div>

                  <div class="row mt-3">
                    <div class="col-3">
                      <h6 class="heading-small text-muted">Deliver To</h6>
                      <a-select style="width: 100%" v-model="filterText.filterDeliveryTo"
                        @dropdownVisibleChange="openDeliveryToOptions" showSearch :filterOption="filterOption">
                        <a-select-option v-for="option in filterDeliveryToOptions" v-bind:key="option.key">
                          {{ option.value }}</a-select-option>
                      </a-select>
                    </div>

                    <div class="col-3">
                      <h6 class="heading-small text-muted">Select Order</h6>
                      <a-select style="width: 100%" v-model="filterText.selectedOrder">
                        <a-select-option v-for="option in selectOrder" v-bind:key="option.key">{{ option.value }}
                        </a-select-option>
                      </a-select>
                    </div>
                    <div class="col-3" v-if="showTerminalFilter">
                      <h6 class="heading-small text-muted">Select Terminal Name</h6>
                      <a-select style="width: 100%" v-model="filterText.selectedTerminalName" @dropdownVisibleChange="openTerminalOptions">
                        <a-select-option v-for="option in terminalNames" v-bind:key="option.key">{{ option.value }}
                        </a-select-option>
                      </a-select>
                    </div>

                    <div v-if='filterText.selectedOrder == 0' class="col-3">
                      <h6 class="heading-small text-muted">Order #</h6>
                      <a-select placeholder="Status" style="width: 100%" v-model="filterText.filterOrderNo">
                        <a-select-option v-for="option in filterOrderNoOptions" v-bind:key="option.key">{{ option.value }}
                        </a-select-option>
                      </a-select>
                    </div>

                    <div v-if='filterText.selectedOrder == 1' class="col-3">
                      <h6 class="heading-small text-muted">Origin #</h6>
                      <a-select placeholder="Status" style="width: 100%" v-model="filterText.filterOriginNo">
                        <a-select-option v-for="option in filterOriginNoOptions" v-bind:key="option.key">{{ option.value
                        }}
                        </a-select-option>
                      </a-select>
                    </div>

                    <div v-if='filterText.selectedOrder == 2' class="col-3">
                      <h6 class="heading-small text-muted">Quantity</h6>
                      <a-select placeholder="Status" style="width: 100%" v-model="filterText.filterQuantity">
                        <a-select-option v-for="option in filterQunatityOptions" v-bind:key="option.key">{{ option.value
                        }}
                        </a-select-option>
                      </a-select>
                    </div>
                  </div>
                </a-spin>
              </div>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </div>
  </div>
</template>

<script>
  import HTTPRequest from '../controllers/httpRequest.js'
  import { mapState } from 'vuex'
  import Autocomplete from 'vuejs-auto-complete';
  import secureStorage from '../controllers/secureStorage.js'

  import moment from 'moment'

  export default {
    components: {
      Autocomplete
    },
    computed: {
      ...mapState(['currentProfile', 'endPoint', 'serverType']),
    },
    data: function(){
      return {
        company:[],
        supplier:[],
        user:[],
        puser:[],
        b2b:[],
        customer:[],
        companies:[],
        suppliers:[],
        users:[],
        pusers:[],
        b2bs:[],
        customers:[],
        filter_company: '',
        filterText: {
                defaultFilterDateValue: [(secureStorage.getItem(`${secureStorage.getItem('documentTypeCode')}_documentSearchDateFrom`) == null || secureStorage.getItem(`${secureStorage.getItem('documentTypeCode')}_documentSearchDateFrom`) === 'Invalid date' ) ? moment(new Date()).format('YYYY-MM-DD') : moment(secureStorage.getItem(`${secureStorage.getItem('documentTypeCode')}_documentSearchDateFrom`)), 
                                        (secureStorage.getItem(`${secureStorage.getItem('documentTypeCode')}_documentSearchDateTo`) == null || secureStorage.getItem(`${secureStorage.getItem('documentTypeCode')}_documentSearchDateTo`) === 'Invalid date'  )? moment(new Date()).format('YYYY-MM-DD') : moment(secureStorage.getItem(`${secureStorage.getItem('documentTypeCode')}_documentSearchDateTo`))],
                filterStatus: '',
                filterDateBy: "document_date",
                filterOrderStatus: '',
                filterOmsStatus: '',
                filterWmsStatus: '',
                filterBrands: [],
                filterBarcode: '',
                filterOrderType: '',
                filterCountryOfOrigin: null,
                filterCompany: null,
                filterFiscalYear: '',
                filterPartyName: '',
                filterYearSeason: '',
                filterCustomer: null,
                filterB2bCustomer: null,
                filterSiteConcept: [],
                filterProdStockNo: [],
                prodStockNoOptions: [],
                filterDocumentCode: '',
                filterDocumentNo:'',
                filterSupplier: '',
                filterPurpose:'',
                filterCreatedBy: '',
                filterPostedBy: '',
                filterDeliveryTo: '',
                filterQuantity: '',
                filterOrderNo: '',
                filterOriginNo: '',
                selectedOrder: 0,
                filterOrderSource:'',
                selectedTerminalName:'',
                filterCasNo: ''
              },
        selectedRefFilter: null,
        tags: [],
        referenceFilters: {},
        filterCaption: "Choose reference",
        searchText: "",
        datePickerPlaceholder: ['Start', 'End'],
        documentReference: [],
        searchDateFrom: null,
        searchDateTo: null,
        loadUserInfos: false,
        firstRunLoadInfos: false,
        firstRunLoadBrands: false,
        firstRunLoadCompanies: false,
        firstRunLoadCountries: false,
        firstRunLoadSiteConcepts: false,
        firstRunLoadTerminals: false,
        firstRunLoadDeliveryTo: false,
        firstRunLoadUsers: false,
        firstRunLoadSuppliers: false,
        firstRunLoadPurpose:false,
        // filterStatus: '',
        // filterOrderStatus: '',
        showOrderStatus: false,
        showOmsStatus: false,
        showWmsStatus: false,
        showBrandFilter: false,
        showBarcodeFilter: false,
        showOrderTypeFilter: false,
        showCountryOfOriginFilter: false,
        showFiscalYearFilter: false,
        showPartyNameFilter: false,
        showYearSeasonFilter: false,
        showCustomerFilter: false,
        showB2bCustomerFilter: false,
        showSiteConceptFilter: false,
        showProdStockNoFilter: false,
        showSiteFilter: false,
        showOriginDocumentFilter: false,
        showDocumentNoFilter:false,
        showOrderSource: false,
        showCasNo: false,
        openSupplierList: false,
        showTerminalFilter:false,
        terminalNames:[],
        // filterDocumentCode: '',
        // defaultFilterDateValue: [moment(new Date()).subtract('30', 'days'), moment(new Date())],
        sites: [],
        companies: [],
        // filterSite: {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")},
        filterSite: (secureStorage.getItem("currentSiteSiteType") == 'ho') ? {key: 0, label: 'All'} : {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")},
        filter_company: {key: 0, label: 'All'},
        //this.sites.push({id: 0, code: 'All', name: 'All'})
        fetching: false,
        docType : secureStorage.getItem('documentTypeCode'),
        filterStatusOptions: [
          {key: "", value: "All"},
          {key: "S", value: "Saved"},
          {key: "C", value: "Confirmed"},
          {key: "P", value: "Posted"},
          {key: "V", value: "Voided"}
        ],
        filterOrderStatusOptions: [
          {key: "", value: "All"},
          {key: "U", value: "Unfulfilled"},
          {key: "P", value: "Partial"},
          {key: "F", value: "Fulfilled"},
          {key: "D", value: "Done"},
        ],
        filterDeliveryOrderStatusOptions: [
          {key: "", value: "All"},
          {key: "O", value: "Open Delivery"},
          {key: "G", value: "Goods Issued"},
        ],
        filterOmsStatusOptions: [
          {key: "", value: "All"},
          {key: "400", value: "Processing"},
          {key: "460", value: "Ready to Ship"},
          {key: "500", value: "Shipped"},
          {key: "600", value: "Delivering"},
          {key: "900", value: "Completed"},
          {key: "800", value: "Returned"},
          {key: "700", value: "Cancelled by seller"},
          {key: "701", value: "Cancelled by operator"},
          {key: "702", value: "Cancelled by partner"},
          {key: "703", value: "Cancelled by system"},
          {key: "708", value: "Cancelled by lost items at warehouse"}
        ],
        filterWmsStatusOptions: [
          {key: "", value: "All"},
          {key: "0", value: "No Status"},
          {key: "210", value: "Awaiting process at warehouse"},
          {key: "705", value: "Cancelled at warehouse"},
          {key: "700", value: "Cancelled by sellers"},
          {key: "800", value: "Delivered"},
          {key: "217", value: "Processing at warehouse"},
          {key: "211", value: "Ready to ship at warehouse"},
          {key: "212", value: "Out of stock"},
          {key: "300", value: "Shipped" }
          // {key: "701", value: "Cancelled by operator"},
          // {key: "703", value: "Cancelled by system"},
          // {key: "708", value: "Cancelled by lost item"},
          // {key: "801", value: "Fulfilled"},
          // {key: "12", value: "Awaiting Reservation"},
          // {key: "304", value: "In-transit"},
          // {key: "10", value: "Received"},
          // {key: "11", value: "Partial inspection"},
          // {key: "6", value: "Completed"},
          // {key: "5", value: "Cancelled"}
        ],
        filterBrandOptions: [],
        filterOrderTypeOptions: [
          {key: "Main Buy", value: "Main Buy"},
          {key: "2nd Buy", value: "2nd Buy"},
          {key: "3rd Buy", value: "3rd Buy"},
          {key: "4th Buy", value: "4th Buy"},
          {key: "5th Buy", value: "5th Buy"},
          {key: "6th Buy", value: "6th Buy"},
          {key: "Additional Order", value: "Additional Order"},
          {key: "ATS/Chase Buy", value: "ATS/Chase Buy"},
          {key: "Collab", value: "Collab"},
          {key: "Custom Order", value: "Custom Order"},
          {key: "Non Trade", value: "Non Trade"},
          {key: "SMU", value: "SMU"},
          {key: "Jan Drop", value: "Jan Drop"},
          {key: "Feb Drop", value: "Feb Drop"},
          {key: "Mar Drop", value: "Mar Drop"},
          {key: "Apr Drop", value: "Apr Drop"},
          {key: "May Drop", value: "May Drop"},
          {key: "Jun Drop", value: "Jun Drop"},
          {key: "Jul Drop", value: "Jul Drop"},
          {key: "Aug Drop", value: "Aug Drop"},
          {key: "Sep Drop", value: "Sep Drop"},
          {key: "Oct Drop", value: "Oct Drop"},
          {key: "Nov Drop", value: "Nov Drop"},
          {key: "Dec Drop", value: "Dec Drop"}
        ],
        filterCountryOfOriginOptions: [{ id: null, name: "All" }],
        filterCompanyOptions: [{ id: null, name: "All" }],
        filterFiscalYearOptions: [],
        filterCustomerOptions: [],
        filterB2bCustomerOptions: [],
        filterSiteConceptOptions: [],
        filterProdStockNoOptions: [],
        filterSupplierOptions: [{ id: "", name: "All" }],
        filterPurposeOptions: [],
        filterCreatedByOptions: [{ id: "", code: "All", name: "All" }],
        filterPostedByOptions: [{ id: "", code: "All", name: "All" }],
        filterDeliveryToOptions: [{ key: "", value: "All" }],
        filterQunatityOptions: [
          {key: "ASC", value: "A ➤ Z"},
          {key: "DESC", value: "Z ➤ A"}
        ],
        filterOrderNoOptions: [
          {key: "ASC", value: "A ➤ Z"},
          {key: "DESC", value: "Z ➤ A"}
        ],
        filterOriginNoOptions: [
          {key: "ASC", value: "A ➤ Z"},
          {key: "DESC", value: "Z ➤ A"}
        ],
        selectOrder: [
          {key: 0, value: "Order #"},
          {key: 1, value: "Origin #"},
          {key: 2, value: "Quantity"},
        ],
        isHo: false,
        filterOrderSourceOptions: [
          {key: "", value: "All"},
          {key: "add_on", value: "Add On"},
          {key: "barter_tool", value: "Barter Tool"},
          {key: "barter_tool_3p", value: "Barter Tool 3P"},
          {key: "receiving_report", value: "Receiving Report"},
        ],
        filterCasNo: '',
        spinning: false
      }
    },
    mounted: async function () {
        var currentDocumentTypeId = secureStorage.getItem('documentTypeId')
        var document_config = await this.getDocumentTypeSettings(currentDocumentTypeId)
        if (document_config) {
          this.documentReference = document_config.document_type_settings.references;
          if (this.currentProfile != "product_price_worksheets") this.selectedRefFilter = this.documentReference[0].name
        }

        this.update_filter();
        this.loadFilterState();

        //Filter By site Only for Branch Session
        if(secureStorage.getItem("currentSiteSiteType") != 'ho'){
          this.filterSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
        }

        await this.applyFilter();

    },
    watch: {
      currentProfile: async function() {
        this.update_filter();
      },
      "filterText.selectedOrder": function(value) {
        if(value == 0){
          this.filterText.filterQuantity = ""
          this.filterText.filterOriginNo = ""
          this.filterText.filterOrderNo = "ASC"
        }else if(value == 1){
          this.filterText.filterOrderNo = ""
          this.filterText.filterOriginNo = "ASC"
          this.filterText.filterQuantity = ""
        }else{
          this.filterText.filterOrderNo = ""
          this.filterText.filterOriginNo = ""
          this.filterText.filterQuantity = "ASC"
        }
      }
    },
    beforeMount: async function() {
        var start_year = new Date().getFullYear();
        for (var i = start_year; i > start_year - 5; i--) {
            var year_from = (i).toString().substring(2, 4);
            var year_to = (i+1).toString().substring(2, 4);
            this.filterFiscalYearOptions.push({key: "FY"+year_from+"-"+year_to, value: "FY"+year_from+"-"+year_to}, {key: "CY"+year_from+"-"+year_to, value: "CY"+year_from+"-"+year_to})
        }
    },
    methods: {
      // save all filter states to secureStorage
      saveFilterState() {
        const documentTypeCode = secureStorage.getItem('documentTypeCode');
        const filterKey = `${documentTypeCode}_filterState`;
        
        const filterState = {
          filterSite: this.filterSite,
          searchDateFrom: this.searchDateFrom,
          searchDateTo: this.searchDateTo,
          filterText: { ...this.filterText },
          referenceFilters: { ...this.referenceFilters },
          tags: [...this.tags],
          selectedRefFilter: this.selectedRefFilter
        };
        
        secureStorage.setItem(filterKey, JSON.stringify(filterState));
      },

      // load all filter states from secureStorage
      loadFilterState() {
        const documentTypeCode = secureStorage.getItem('documentTypeCode');
        const filterKey = `${documentTypeCode}_filterState`;
        const savedState = secureStorage.getItem(filterKey);
        
        if (savedState) {
          try {
            const filterState = JSON.parse(savedState);

            if (filterState.filterSite) {
              this.filterSite = filterState.filterSite;
            }

            if (filterState.searchDateFrom) {
              this.searchDateFrom = filterState.searchDateFrom;
            }
            if (filterState.searchDateTo) {
              this.searchDateTo = filterState.searchDateTo;
            }

            if (filterState.filterText) {
              Object.keys(filterState.filterText).forEach(key => {
                if (this.filterText.hasOwnProperty(key)) {
                  this.filterText[key] = filterState.filterText[key];
                }
              });

              if (filterState.filterText.defaultFilterDateValue) {
                this.filterText.defaultFilterDateValue = [
                  moment(filterState.filterText.defaultFilterDateValue[0]),
                  moment(filterState.filterText.defaultFilterDateValue[1])
                ];
              }
            }

            if (filterState.referenceFilters) {
              this.referenceFilters = { ...filterState.referenceFilters };
            }
            if (filterState.tags) {
              this.tags = [...filterState.tags];
            }

            if (filterState.selectedRefFilter) {
              this.selectedRefFilter = filterState.selectedRefFilter;
            }
            
          } catch (error) {
            console.error('Error loading filter state:', error);
          }
        }
      },

      // clear all saved filter states
      clearFilterState() {
        const documentTypeCode = secureStorage.getItem('documentTypeCode');
        const filterKey = `${documentTypeCode}_filterState`;
        secureStorage.removeItem(filterKey);
        secureStorage.removeItem(`${documentTypeCode}_documentSearchDateFrom`);
        secureStorage.removeItem(`${documentTypeCode}_documentSearchDateTo`);
      },
      resetDateScopedDropdownOptions() {
        this.firstRunLoadTerminals = false
        this.firstRunLoadDeliveryTo = false
        this.terminalNames = []
        this.filterDeliveryToOptions = [{ key: "", value: "All" }]
      },

      clearFilters() {
        // clear current filter state
        this.filterText = {
          defaultFilterDateValue: [moment(new Date()).format('YYYY-MM-DD'), moment(new Date()).format('YYYY-MM-DD')],
          filterStatus: '',
          filterDateBy: "document_date",
          filterOrderStatus: '',
          filterOmsStatus: '',
          filterWmsStatus: '',
          filterBrands: [],
          filterBarcode: '',
          filterOrderType: '',
          filterCountryOfOrigin: null,
          filterCompany: null,
          filterFiscalYear: '',
          filterPartyName: '',
          filterYearSeason: '',
          filterCustomer: null,
          filterB2bCustomer: null,
          filterSiteConcept: [],
          filterProdStockNo: [],
          filterDocumentCode: '',
          filterDocumentNo:'',
          filterSupplier: '',
          filterPurpose:'',
          filterCreatedBy: '',
          filterPostedBy: '',
          filterDeliveryTo: '',
          filterQuantity: '',
          filterOrderNo: '',
          filterOriginNo: '',
          selectedOrder: 0,
          filterOrderSource:'',
          selectedTerminalName:'',
          filterCasNo: ''
        };

        this.filterSite = (secureStorage.getItem("currentSiteSiteType") == 'ho') ? {key: 0, label: 'All'} : {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")};
        this.searchDateFrom = moment(new Date()).format('YYYY-MM-DD');
        this.searchDateTo = moment(new Date()).format('YYYY-MM-DD');
        this.referenceFilters = {};
        this.tags = [];
        this.selectedRefFilter = (this.documentReference && this.documentReference[0]) ? this.documentReference[0].name : null;
        this.supplier = { key: '', label: '' };
        this.user = { key: '', label: '' };
        this.puser = { key: '', label: '' };
        this.b2b = { key: '', label: '' };
        this.customer = { key: '', label: '' };
        this.resetDateScopedDropdownOptions();

        // clear saved state
        this.clearFilterState();
        this.applyFilter();
      },

      selectCompany (company, option){
                company = company.replace('companies','')
                var arr = {
                    key:company,
                    label: option.data.attrs.text
                }
                company = arr
                Object.assign(this, {
                    company,
                    companies: [],
                    fetching: false,
                });

                if(this.company.key != null && this.company.key != ""  && this.company.key != []){
                    this.filterText.filterCompany = this.company.key
                    this.filter_company['key'] = this.company.key
                }
        },
      async fetchCompanies(value){
              this.company = {key: '', label: value}
              this.fetching = true
              if (value != undefined && value != '')
                this.companies = await HTTPRequest.getRequest(this.endPoint + 'companies/get_valid_companies?name='+value, null)
              this.fetching = false
        },
        selectSupplier(supplierId, option){
          const selectedSupplier = this.suppliers.find(s => s.id.toString() === supplierId);
          if (selectedSupplier) {
            this.supplier = {
              key: selectedSupplier.id,
              label: selectedSupplier.name
            };
            this.filterText.filterSupplier = selectedSupplier.id;
          }
        },
        handleSupplierChange(value){
          if (!value) {
            this.supplier = { key: '', label: '' };
            this.filterText.filterSupplier = '';
          }
        },
        retainSupplier(supplierId){
          if (!supplierId) return;
          const selectedSupplier = this.suppliers.find(s => s.id.toString() === supplierId.toString());
          if (selectedSupplier) {
            this.supplier.label = selectedSupplier.name;
          }
        },
      async fetchSuppliers(value){
              this.supplier = {key: '', label: value}
              this.fetching = true
              if (value != undefined && value != '')
                this.suppliers = await HTTPRequest.getRequest(this.endPoint + 'suppliers/get_valid_suppliers?name='+value, null)
              this.fetching = false
        },
        selectUser (user, option){
                user = user.replace('users','')
                var arr = {
                    key:user,
                    label: option.data.attrs.text
                }
                user = arr
                Object.assign(this, {
                    user,
                    users: [],
                    fetching: false,
                })

                if(this.user.key != null && this.user.key != ""  && this.user.key != []){
                    this.filterText.filterCreatedBy = this.user.key
                }
        },
        async fetchUsers(value){
              this.user = {key: '', label: value}
              this.fetching = true
              if (value != undefined && value != '')
                this.users = await HTTPRequest.getRequest(this.endPoint + 'users/get_all_users?name='+value, null)
              this.fetching = false
        },
        selectPostedUser (puser, option){
                puser = puser.replace('users','')
                var arr = {
                    key:puser,
                    label: option.data.attrs.text
                }
                puser = arr
                Object.assign(this, {
                    puser,
                    pusers: [],
                    fetching: false,
                })

                if(this.puser.key != null && this.puser.key != ""  && this.puser.key != []){
                    this.filterText.filterPostedBy = this.puser.key
                }
        },
        async fetchPUsers(value){
              this.puser = {key: '', label: value}
              this.fetching = true
              if (value != undefined && value != '')
                this.pusers = await HTTPRequest.getRequest(this.endPoint + 'users/get_all_users?name='+value, null)
              this.fetching = false
        },
        selectB2bCustomer (b2b, option){
                b2b = b2b.replace('b2b','')
                var arr = {
                    key:b2b,
                    label: option.data.attrs.text
                }
                b2b = arr
                Object.assign(this, {
                    b2b,
                    b2bs: [],
                    fetching: false,
                })

                if(this.b2b.key != null && this.b2b.key != ""  && this.b2b.key != []){
                    this.filterText.filterB2bCustomer = this.b2b.key
                }
        },
        handleAutoCompleteChange(value) {
          if (!value) {
            // Clear the b2b object and filter text when input is empty
            this.b2b = { key: null, label: '' };
            this.filterText.filterB2bCustomer = '';
          }
        },
        async fetchB2bCustomers(value){
              this.b2b = {key: '', label: value}
              this.fetching = true
              if (value != undefined && value != '')
                this.b2bs = await HTTPRequest.getRequest(this.endPoint + 'b2b_customers/get_valid_b2b_customers?name='+value, null)
              this.fetching = false
        },
        selectCustomer (customer, option){
                customer = customer.replace('customer','')
                var arr = {
                    key:customer,
                    label: option.data.attrs.text
                }
                customer = arr
                Object.assign(this, {
                    customer,
                    customers: [],
                    fetching: false,
                })

                if(this.customer.key != null && this.customer.key != ""  && this.customer.key != []){
                    this.filterText.filterCustomer = this.customer.key
                }
        },
        async fetchCustomers(value){
              this.customer = {key: '', label: value}
              this.fetching = true
              if (value != undefined && value != '')
                this.customers = await HTTPRequest.getRequest(this.endPoint + 'customers/get_valid_customers?name='+value, null)
              this.fetching = false
        },
        
      doFilter: async function(){
        secureStorage.setItem(`${secureStorage.getItem('documentTypeCode')}_documentSearchDateFrom`, this.searchDateFrom)
        secureStorage.setItem(`${secureStorage.getItem('documentTypeCode')}_documentSearchDateTo`, this.searchDateTo)
      },
      async getDocumentTypeSettings(currentDocumentTypeId) {
        var cacheKey = `document_type_settings_${secureStorage.getItem("accountId")}_${currentDocumentTypeId}`
        var cachedDocumentConfig = secureStorage.getItem(cacheKey)
        if (cachedDocumentConfig) return cachedDocumentConfig

        var document_config = await HTTPRequest.getRequest(this.endPoint+'/document_types/get_document_type_settings?id='+ currentDocumentTypeId, null)
        if (document_config) secureStorage.setItem(cacheKey, document_config)
        return document_config
      },
      async getBrandOptions() {
        const brands = await HTTPRequest.getRequest(this.endPoint + "/brands/get_valid_brands?mode=all", null, null);
        this.filterBrandOptions = brands.map(brand => ({ id: brand.id, name: brand.name }));
      },
      async getActiveUsersOptions() {
        const users = await HTTPRequest.getRequest(this.endPoint + '/users/get_active_users')
        const mappedUsers = users.map(user => ({ id: user.id, code: user.code, name: user.name }));

        this.filterCreatedByOptions = [
          { id: "", code: "", name: "All" }, 
          ...mappedUsers
        ];

        this.filterPostedByOptions = [
          { id: "", code: "", name: "All" }, 
          ...mappedUsers
        ];
      },
      async getSupplierOptions(value) {
        const suppliers = await HTTPRequest.getRequest(this.endPoint + '/suppliers/get_valid_suppliers')
        const mappedSuppliers = suppliers.map(supplier => ({ id: supplier.id, name: supplier.name }));

        this.filterSupplierOptions = [
          { id: "", name: "All" }, 
          ...mappedSuppliers
        ];
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      async getCountryOptions() {
        var countries = await HTTPRequest.getRequest(this.endPoint + '/countries/get_valid_countries', null, null);
        this.filterCountryOfOriginOptions = countries.map(country => ({ id: country.id, name: country.name }));
      },
      async getTerminalOptions(currentDocumentTypeId) {
        currentDocumentTypeId = currentDocumentTypeId || secureStorage.getItem('documentTypeId')
        this.terminalNames = []
        var get_data = await HTTPRequest.getRequest(this.endPoint+`/documents?document_type_id=${currentDocumentTypeId}&site_id=${this.filterSite.key}&is_terminal=true${this.getDocumentDateParams()}`)
        if(get_data){
          for(let i = 0; i < get_data.length; i++){
            var source = get_data[i]; 
            if(!this.terminalNames.some(e => e.value == source)){
              let data3 = {
                key: source,
                value: source
              }
              this.terminalNames.push(data3)
            }
          }
        }
      },
      async getDeliveryToOptions(currentDocumentTypeId) {
        currentDocumentTypeId = currentDocumentTypeId || secureStorage.getItem('documentTypeId')
        this.filterDeliveryToOptions = [{key: "", value: "All"}]
        var get_data = await HTTPRequest.getRequest(this.endPoint+`/documents/get_delivery_to_details?document_type_id=${currentDocumentTypeId}&site_id=${this.filterSite.key}${this.getDocumentDateParams()}`)

        if(get_data){
          for(let i = 0; i < get_data.length; i++){
            var source = get_data[i];
            if(!this.filterDeliveryToOptions.some(e => e.value == source.name)){
              let data3 = {
                key: source.id,
                value: source.name
              }
              this.filterDeliveryToOptions.push(data3)
            }
          }
        }

        this.filterDeliveryToOptions = [
          {key: "", value: "All"},
          ...this.filterDeliveryToOptions
            .filter(option => option.key !== "")
            .sort((a, b) => a.value.localeCompare(b.value))
        ]
      },
      async refreshDocumentDropdownOptions(currentDocumentTypeId) {
        currentDocumentTypeId = currentDocumentTypeId || secureStorage.getItem('documentTypeId')
        await this.getTerminalOptions(currentDocumentTypeId)
        await this.getDeliveryToOptions(currentDocumentTypeId)
      },
      async openDeliveryToOptions(open) {
        if(open && !this.firstRunLoadDeliveryTo) {
          this.firstRunLoadDeliveryTo = true
          await this.getDeliveryToOptions()
        }
      },
      async openTerminalOptions(open) {
        if(open && !this.firstRunLoadTerminals) {
          this.firstRunLoadTerminals = true
          await this.getTerminalOptions()
        }
      },
      getDocumentDateParams() {
        var params = ''
        if (this.searchDateFrom && this.searchDateTo) {
          params += `&searchDateFrom=${encodeURIComponent(this.searchDateFrom)}&searchDateTo=${encodeURIComponent(this.searchDateTo)}`
        }
        if (this.filterText.filterDateBy) {
          params += `&filter_date_by=${encodeURIComponent(this.filterText.filterDateBy)}`
        }
        return params
      },
      async openBrandOptions(open) {
        if(open && !this.firstRunLoadBrands) {
          this.firstRunLoadBrands = true
          await this.getBrandOptions()
        }
      },
      async openCompanyOptions(open) {
        if(open && !this.firstRunLoadCompanies) {
          this.firstRunLoadCompanies = true
          await this.getCompanyOptions()
        }
      },
      async openCountryOptions(open) {
        if(open && !this.firstRunLoadCountries) {
          this.firstRunLoadCountries = true
          await this.getCountryOptions()
        }
      },
      async openSiteConceptOptions(open) {
        if(open && !this.firstRunLoadSiteConcepts) {
          this.firstRunLoadSiteConcepts = true
          await this.getSiteConceptOptions()
        }
      },
      
      async getCompanyOptions() {
        var companies = await HTTPRequest.getRequest(this.endPoint + '/companies/get_valid_companies', null, null);
        this.filterCompanyOptions = [
          { id: null, name: "All" },
          ...companies.map(company => ({ id: company.id, name: company.name }))
        ];
      },
      async getCustomerOptions() {
        const customers = await HTTPRequest.getRequest(this.endPoint + '/customers/get_valid_customers', null, null);
        this.filterCustomerOptions = customers.map(customer => ({ id: customer.id, name: customer.name }));
      },
      async getB2bCustomerOptions() {
        const b2b_customers = await HTTPRequest.getRequest(this.endPoint + '/b2b_customers/get_valid_b2b_customers', null, null);
        this.filterB2bCustomerOptions = b2b_customers
          .map(b2b_customer => ({ id: b2b_customer.id, name: b2b_customer.name }))
          .sort((a, b) => a.name.localeCompare(b.name));
      },
      async getSiteConceptOptions() {
        const site_concepts = await HTTPRequest.getRequest(this.endPoint + '/site_concepts/get_valid_site_concepts', null, null);
        site_concepts.sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
        this.filterSiteConceptOptions = site_concepts.map(site_concept => ({ id: site_concept.id, name: site_concept.name }));
      },
      async handleDropdownSearchData(value) {
        if (value) {
          const products = await this.getProductStockNoOptions(value);
          this.filterProdStockNoOptions = products.map(product => ({ id: product.id, stock_no: product.stock_no }));
        } else {
          this.filterProdStockNoOptions = [];
        }
      },
      async getProductStockNoOptions(searchValue) {
        const response = await HTTPRequest.getRequest(this.endPoint + '/products/get_valid_products', { stock_no: searchValue });
        return response;
      },
      handleClose(removedTag){
        var tagArray = removedTag.split(": ")
        var hashKey = tagArray[0]
        delete this.referenceFilters[hashKey]
        const tags = this.tags.filter(tag => tag !== removedTag)
        this.tags = tags
      },
      openSupplier: async function(open){
        if(open && !this.firstRunLoadSuppliers){
          this.firstRunLoadSuppliers = true
          let suppliers_data = await HTTPRequest.getRequest(this.endPoint+'/suppliers/get_valid_suppliers', null)
          this.filterSupplierOptions = suppliers_data
          this.filterSupplierOptions.sort((a, b) => a.name.localeCompare(b.name))
          this.filterSupplierOptions.unshift({id: "", name: "All"});
        }
      },
      openPurpose:async function(open){
        if(open && !this.firstRunLoadPurpose){
          this.firstRunLoadPurpose = true
          let purpose_data = await HTTPRequest.getRequest(this.endPoint+'/purposes/get_valid_purposes?document_type_id='+secureStorage.getItem('documentTypeId'), null)
          this.filterPurposeOptions = purpose_data
          this.filterPurposeOptions.sort((a, b) => a.name.localeCompare(b.name))
          this.filterPurposeOptions.unshift({id: "", name: "All"});
        }
      },
      openUserList: async function(open){
        if(open && !this.firstRunLoadUsers){
          this.firstRunLoadUsers = true
          let active_users = await HTTPRequest.getRequest(this.endPoint+'/users/get_active_users')
          let sortedUsers = (active_users || []).slice().sort((a, b) => String(a.code).localeCompare(String(b.code)))
          // Build two independent arrays so Created By / Posted By don't share a reference
          this.filterCreatedByOptions = [{id: "", code: "All", name: "All"}, ...sortedUsers]
          this.filterPostedByOptions = [{id: "", code: "All", name: "All"}, ...sortedUsers]
        }
      },
      openDrawer: function(){
        if(!this.firstRunLoadInfos){
          this.firstRunLoadInfos = true
          this.loadUserInfos = true
          this.filterText.filterOrderNo = "ASC"
          // this.filterSupplierOptions.push({id: "", name: "All"});
          // this.filterCreatedByOptions.push({id: "", code: "All" , name: "All"})
          // this.filterPostedByOptions.push({id: "", code: "All" , name: "All"})
          // this.filterText.filterCreatedBy = 'All'
          // this.filterText.filterPostedBy = 'All'
          this.loadUserInfos = false
        }
      },
      addReferenceFilter(value){
        if(_.isUndefined(this.referenceFilters[this.selectedRefFilter])){
          console.log(value)
          var index = this.documentReference.findIndex(p => p.name == this.selectedRefFilter)
          this.referenceFilters[this.selectedRefFilter] = {value: this.searchText, field: "reference_" + (index + 1).toString()}
          this.tags.push(this.selectedRefFilter + ": " + this.searchText)
          this.searchText = ""
        }else{
          alert("Filter exist.")
        }

      },
      update_filter(){
        var currentDocumentTypeCode = secureStorage.getItem('documentTypeCode')
        var accountName = secureStorage.getItem("accountName")
        var isPiml = accountName.toLowerCase().includes('piml')
        //Clear filter data
        //this.filterSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
        this.filterSite= (secureStorage.getItem("currentSiteSiteType") == 'ho') ? {key: 0, label: 'All'} : {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")},
        this.defaultFilterDateValue = [moment(new Date()), moment(new Date())]
        this.searchDateFrom = moment(new Date()).format('YYYY-MM-DD')
        this.searchDateTo = moment(new Date()).format('YYYY-MM-DD')
        this.filterStatus =  ''
        this.filterOrderStatus = ''
        this.filterOmsStatus = ''
        this.filterWmsStatus = ''
        this.filterBrands = [],
        this.filterBarcode = '',
        this.filterOrderType = '',
        this.filterCountryOfOrigin = [],
        this.filterCompany = [],
        this.filterFiscalYear = '',
        this.filterYearSeason = '',
        this.filterCustomer = [],
        this.filterB2bCustomer = [],
        this.filterSiteConcept = [];
        this.filterProdStockNo = [];
        this.filterDocumentCode = ''
        this.filterDocumentNo = ''
        this.filterDateBy = ''
        this.filterPartyName = ''
        this.filterOrderSource = ''

        let currentSiteSiteType = secureStorage.getItem("currentSiteSiteType")
        this.isHo = currentSiteSiteType
        this.showSiteFilter = (this.serverType == 'ho' || currentDocumentTypeCode == 'ORITRQ' || currentDocumentTypeCode == 'OROTRQ') ? true : false;
        this.showSiteFilter = (currentSiteSiteType  == 'ho' || currentDocumentTypeCode == 'ORITRQ' || currentDocumentTypeCode == 'OROTRQ') ? true : false;
        this.showSiteFilter = (this.serverType == 'ho' || currentDocumentTypeCode == 'ORICSQ' || currentDocumentTypeCode == 'OROCSQ') ? true : false;
        this.showSiteFilter = (currentSiteSiteType  == 'ho' || currentDocumentTypeCode == 'ORICSQ' || currentDocumentTypeCode == 'OROCSQ') ? true : false;
        this.showSiteFilter = (currentSiteSiteType  == 'ho' || currentDocumentTypeCode == 'OTHPWS') ? true : false;
        this.showSiteFilter = (currentSiteSiteType  == 'ho' || currentDocumentTypeCode == 'RELTRX') ? true : false;
        this.showBarcodeFilter = true;
        // this.showSiteFilter = (this.currentProfile  == 'product_price_worksheets') ? true : false;

        switch(currentDocumentTypeCode) {
          case 'ORITRQ':
            this.showOrderStatus = true;
            break;
          case 'OROTRQ':
            this.showOrderStatus = true;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            break;
          case 'RECTRX':
            this.showOrderStatus = false;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            this.showWmsStatus = true;
            this.showBrandFilter = true;
            this.showSiteConceptFilter = true;
            this.showProdStockNoFilter = true;
            this.showCasNo = true;

            break;
          case 'RELTRX': // Transfer Out
            this.showOrderStatus = false;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            this.showBrandFilter = true;
            this.showWmsStatus = true;
            this.showSiteConceptFilter = true;
            this.showProdStockNoFilter = true;
            this.showCasNo = true;
            break;
          case 'RELSLO':
            this.showOrderStatus = false;
            this.showWmsStatus = true;
            this.showBrandFilter = true;
            break;
          case 'RECSLI':
            this.showWmsStatus = true;
            this.showBrandFilter = true;
            break;
          case 'ORICSQ':
            this.showOrderStatus = true;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            break;
          case 'OROCSQ':
            this.showOrderStatus = true;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            break;
          case 'RECCSX':
            this.showOrderStatus = false;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            break;
          case 'RELCSX':
            this.showOrderStatus = false;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            break;
          case 'OTHPUR':
            this.showOrderStatus = false;
            this.showBrandFilter = true;
            this.showOrderTypeFilter = true;
            this.showCountryOfOriginFilter = true;
            this.showFiscalYearFilter = true;
            this.showYearSeasonFilter = true;
            this.showBarcodeFilter = true;
            break;
          case 'ORIPOX':
            this.showOrderStatus = true;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            this.showBrandFilter = true;
            this.showOrderTypeFilter = true;
            this.showCountryOfOriginFilter = true;
            this.showFiscalYearFilter = true;
            this.showYearSeasonFilter = true;
            this.showBarcodeFilter = true;
            break;
          case 'ORIASN':
            this.showOrderStatus = true;
            this.showDocumentNoFilter = true;
            this.showWmsStatus = true;
            this.showBrandFilter = true;
            this.showOrderTypeFilter = true;
            this.showCountryOfOriginFilter = true;
            this.showFiscalYearFilter = true;
            this.showYearSeasonFilter = true;
            this.showBarcodeFilter = true;
            this.showCasNo = true;
            break;
          case 'RECDEL': // Receiving Report
            this.showOrderStatus = false;
            this.showDocumentNoFilter = true;
            this.showWmsStatus = true;
            this.showBrandFilter = true;
            this.showOrderTypeFilter = true;
            this.showCountryOfOriginFilter = true;
            this.showFiscalYearFilter = true;
            this.showYearSeasonFilter = true;
            break;
          case 'RELRSR':
            this.showOrderStatus = false;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            this.showWmsStatus = true;
            this.showBrandFilter = true;
            this.showOrderTypeFilter = true;
            this.showCountryOfOriginFilter = true;
            this.showFiscalYearFilter = true;
            this.showYearSeasonFilter = true;
            break;
          case 'RECADJ':
            this.showOrderStatus = false;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            this.showBrandFilter = true;
            this.showCasNo = true;
            break;
          case 'RELADJ':
            this.showOrderStatus = false;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            this.showBrandFilter = true;
            this.showCasNo = true;
            break;
          case 'OTHTOV':
            this.showBarcodeFilter = true;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            break;
          case 'OTHPCV':
            this.showBarcodeFilter = true;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            break
          case 'OTHPCN':
            this.showOrderStatus = false;
            this.showBrandFilter = true;
            break;
          case 'ORISOX': // Sales Order
            this.showOrderStatus = true;
            this.showWmsStatus = true;
            this.showBrandFilter = true;
            this.showOrderTypeFilter = true;
            this.showCountryOfOriginFilter = true;
            this.showFiscalYearFilter = true;
            this.showYearSeasonFilter = true;
            this.showB2bCustomerFilter = true;
            this.showBarcodeFilter = true;
            this.showCasNo = true;
            this.showDocumentNoFilter = true;
            break;
          case 'ORIOSO': // Online Sales Order
            this.showOrderStatus = true;
            this.showOmsStatus = true;
            this.showBrandFilter = true;
            this.showOrderTypeFilter = true;
            this.showCountryOfOriginFilter = true;
            this.showFiscalYearFilter = true;
            this.showYearSeasonFilter = true;
            this.showPartyNameFilter = true;
            this.showTerminalFilter = true;
            //this.showCustomerFilter = true;
            break;
          case "OTHPWS":
            this.showOrderStatus = false;
            this.showBrandFilter = true;
            this.showSiteFilter = false;
            break;
          case 'OTHSIN':
            this.showDocumentNoFilter = true;
            this.showWmsStatus = true;
            this.showBrandFilter = true;
            this.showOrderTypeFilter = true;
            this.showCountryOfOriginFilter = true;
            this.showFiscalYearFilter = true;
            this.showYearSeasonFilter = true;
            this.showB2bCustomerFilter = true;
            this.showOrderSource = true;
            this.showCasNo = true;
            break;
          case 'OTHSBI':
            this.showDocumentNoFilter = true;
            this.showBrandFilter = true;
            this.showOrderTypeFilter = true;
            this.showCountryOfOriginFilter = true;
            this.showFiscalYearFilter = true;
            this.showYearSeasonFilter = true;
            this.showOrderSource = true
            break;
          case 'RELDDE':
            this.showOrderStatus = true;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            this.showWmsStatus = true;
            this.showBrandFilter = true;
            this.showOrderTypeFilter = true;
            this.showCountryOfOriginFilter = true;
            this.showFiscalYearFilter = true;
            this.showYearSeasonFilter = true;
            this.showB2bCustomerFilter = true;
            this.showCasNo = true;
            break;
          case 'RECCSR':
            this.showWmsStatus = true;
            this.showBrandFilter = true;
            this.showOrderTypeFilter = true;
            this.showCountryOfOriginFilter = true;
            this.showFiscalYearFilter = true;
            this.showYearSeasonFilter = true;
            this.showB2bCustomerFilter = true;
            this.showCasNo = true;
            break;
          case 'RECOCR':
            this.showOmsStatus = true;
            this.showBrandFilter = true;
            this.showOrderTypeFilter = true;
            this.showCountryOfOriginFilter = true;
            this.showFiscalYearFilter = true;
            this.showYearSeasonFilter = true;
            this.showB2bCustomerFilter = true;
            break;
          case 'ORORSO':
            this.showBrandFilter = true;
            this.showOrderTypeFilter = true;
            this.showCountryOfOriginFilter = true;
            this.showFiscalYearFilter = true;
            this.showYearSeasonFilter = true;
            this.showB2bCustomerFilter = true;
            break;
          case 'RELCSI':
            this.showOrderStatus = false;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = false;
            this.showBrandFilter = true;
            break;
          case 'OTHSRQ':
            if (isPiml){
            this.showDocumentNoFilter = true;
            this.showBrandFilter = true;
            this.showOrderTypeFilter = true;
            this.showCountryOfOriginFilter = true;
            this.showFiscalYearFilter = true;
            this.showYearSeasonFilter = true;
            this.showB2bCustomerFilter = true;
            this.showOrderSource = true;
            }
            break;
          default:
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
          }
      },
      moment,
      onDateFilter(date, dateString) {
        this.searchDateFrom = dateString[0]
        this.searchDateTo = dateString[1]
        this.resetDateScopedDropdownOptions()
      },
    async applyFilter() {
      this.spinning = true
      this.retainSupplier(this.filterText.filterSupplier);

      // save filter state before applying
      this.saveFilterState();

      if (secureStorage.getItem('documentTypeCode') == "OTHPWS") {
        this.$emit('changeDocFilter',
          this.filterSite.key,
          this.searchDateFrom,
          this.searchDateTo,
          this.filterText.filterDateBy,
          this.filterText.filterStatus,
          this.filterText.filterOrderStatus,
          this.filterText.filterDocumentCode,
          this.referenceFilters,
          this.filterText.filterSupplier,
          this.filterText.filterCreatedBy,
          this.filterText.filterPostedBy,
          this.filterText.filterDeliveryTo,
          this.filterText.filterQuantity,
          this.filterText.filterOrderNo,
          this.filterText.filterOriginNo,
          this.filterText.filterDocumentNo,
          this.filterText.filterPurpose,
          this.filterText.filterOmsStatus,
          this.filterText.filterWmsStatus,
          this.filterText.filterBrands.length > 0 ? this.filterText.filterBrands : null,
          this.filterText.filterBarcode,
          this.filterText.filterOrderType,
          this.filterText.filterCountryOfOrigin,
          this.filterText.filterCompany,
          this.filterText.filterFiscalYear,
          this.filterText.filterYearSeason,
          this.filterText.filterCustomer,
          this.filterText.filterSiteConcept.length > 0 ? this.filterText.filterSiteConcept : null,
          this.filterText.filterProdStockNo.length > 0 ? this.filterText.filterProdStockNo : null,
          this.spinning
        )
      } else {
        var filterDocumentCode = (this.showOriginDocumentFilter) ? this.filterText.filterDocumentCode : ''
        this.$emit('changeFilter',
          this.filterSite.key,
          this.searchDateFrom,
          this.searchDateTo,
          this.filterText.filterDateBy,
          this.filterText.filterStatus,
          this.filterText.filterOrderStatus,
          filterDocumentCode,
          this.referenceFilters,
          this.filterText.filterSupplier,
          this.filterText.filterCreatedBy,
          this.filterText.filterPostedBy,
          this.filterText.filterDeliveryTo,
          this.filterText.filterQuantity,
          this.filterText.filterOrderNo,
          this.filterText.filterOriginNo,
          this.filterText.filterDocumentNo,
          this.filterText.filterPurpose,
          this.filterText.filterOmsStatus,
          this.filterText.filterWmsStatus,
          this.filterText.filterBrands.length > 0 ? this.filterText.filterBrands : null,
          this.filterText.filterBarcode,
          this.filterText.filterOrderType,
          this.filterText.filterCountryOfOrigin,
          this.filterText.filterCompany,
          this.filterText.filterFiscalYear,
          this.filterText.filterYearSeason,
          this.filterText.filterCustomer,
          this.filterText.filterB2bCustomer,
          this.filterText.filterPartyName,
          this.filterText.filterSiteConcept.length > 0 ? this.filterText.filterSiteConcept : null,
          this.filterText.filterProdStockNo.length > 0 ? this.filterText.filterProdStockNo : null,
          this.filterText.filterOrderSource,
          this.filterText.filterCasNo,
          this.filterText.selectedTerminalName,
          this.spinning
        )
      }

      //Start
      //https://tools.iripple.com/barter-11/bxi-erk-backend/-/issues/68
      //[ERK] BXI to remember user last document filter
        this.doFilter();

      //https://tools.iripple.com/barter-11/bxi-erk-backend/-/issues/68
      //[ERK] BXI to remember user last document filter
      //End

      this.spinning = false
      },
      async fetchSites() {
        if(this.filter_company === undefined){
          this.sites = []
        } else {
          this.fetching = true
          this.sites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites?company='+this.filter_company['key'], null)
          this.sites.push({id: 0, code: 'All', name: 'All'})
          this.fetching = false
        }
      },
      selectSite (filterSite) {
        Object.assign(this, {
          filterSite,
          sites: [],
          fetching: false,
        })
        this.resetDateScopedDropdownOptions()
      }
    }
  }
</script>
<style scoped>
.filter_separator {
  height: 82px !important;
}
</style>
